export type Breakpoints = Array<number>

const breakpoints: Breakpoints = [576, 768, 992, 1200]

export default breakpoints
